var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductQuantity = function SvgProductQuantity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.75 14.26H17M11.75 18.76H17M11.75 9.762H17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.5,
    d: "M8.75 14.636a.375.375 0 0 1 0-.75M8.75 14.636a.375.375 0 0 0 0-.75M8.75 19.136a.375.375 0 0 1 0-.75M8.75 19.136a.375.375 0 0 0 0-.75M8.75 10.137a.375.375 0 1 1 0-.75M8.75 10.137a.375.375 0 1 0 0-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 4.5H20A1.5 1.5 0 0 1 21.5 6v15.75a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5V6A1.5 1.5 0 0 1 5 4.5h3.75a3.75 3.75 0 0 1 7.5 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.5,
    d: "M12.5 4.51a.375.375 0 0 1 0-.75M12.5 4.51a.375.375 0 0 0 0-.75"
  })));
};
export default SvgProductQuantity;